import { render, staticRenderFns } from "./DrawerOtherSpeciality.vue?vue&type=template&id=7c1b76aa"
import script from "./DrawerOtherSpeciality.vue?vue&type=script&lang=js"
export * from "./DrawerOtherSpeciality.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports